import type { ReactNode } from 'react';
import { useCallback, useState } from 'react';

import type { Highlight, OnboardingHighlightName } from './index.tsx';
import { onboardigHighlightContext as HighlightContext } from './index.tsx';

type Props = {
  children: ReactNode;
};

export const OnboardingHighlightProvider = ({ children }: Props) => {
  const [highlights, setHighlights] = useState<Highlight[]>([]);
  const [activeHighlights, setActiveHighlights] = useState<
    OnboardingHighlightName[]
  >([]);

  const registerHighlight = useCallback((highlight: Highlight) => {
    setHighlights(old => {
      const oldWithoutHighlight = old.filter(h => h.name !== highlight.name);

      return [...oldWithoutHighlight, highlight];
    });
  }, []);

  return (
    <HighlightContext.Provider
      value={{
        registerHighlight,
        highlights,
        activeHighlights,
        setActiveHighlights,
      }}
    >
      {children}
    </HighlightContext.Provider>
  );
};
